/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { VatExemptionReductionService } from "services/vat-exemption-reduction";

function ActionCell({ item, index, setDataTable }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      await VatExemptionReductionService.remove(item._id);
      setDataTable((prev) => ({ ...prev, rows: prev.rows.filter((row) => row.id !== item._id) }));
      handleClose();
      toast.success("Xoá thành công");
    } catch (error) {
      toast.error("Xoá thất bại");
      console.log("🍕 ~ error:", error);
      handleClose();
    }
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <Link to={`/templates/detail-ledger-vat-exemption-reduction/${item._id}/view`}>
        <SoftTypography variant="body1" color="success" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Xem chi tiết" placement="top">
            <Icon>visibility</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>
      <SoftBox mx={2}>
        <Link to={`/templates/detail-ledger-vat-exemption-reduction/${item._id}/edit`}>
          <SoftTypography variant="body1" color="info" sx={{ cursor: "pointer", lineHeight: 0 }}>
            <Tooltip title="Cập nhật" placement="top">
              <Icon>edit</Icon>
            </Tooltip>
          </SoftTypography>
        </Link>
      </SoftBox>
      <SoftTypography
        onClick={handleClickOpen}
        variant="body1"
        color="error"
        sx={{ cursor: "pointer", lineHeight: 0 }}
      >
        <Tooltip title="Xóa" placement="left">
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Xóa?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn xóa?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Hủy</Button>
          <Button onClick={handleDelete} autoFocus>
            Đồng ý
          </Button>
        </DialogActions>
      </Dialog>
    </SoftBox>
  );
}

export default ActionCell;
